import { Post } from "../utils/http.js"
import { base64Decode, domainAdaptationURL } from "@/utils/utils"

function randomStr(min, max) {
  let str = ""
  let index = ""
  let range = min
  const arr = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ]
  range = Math.floor(Math.random() * (max - min + 1) + min)
  for (let i = 0; i < range; i++) {
    index = Math.round(Math.random() * (arr.length - 1))
    str += arr[index]
  }
  return str
}

const deviceId = randomStr(1, 10)

let initParams = {}

if (process.client) {
  initParams = {
    appName: "Superweb",
    screen: window.screen.width + "*" + window.screen.height,
    signKey: "0",
    deviceId,
    deviceToken: deviceId,
    appVersion: "1.0.0",
    platform: "WEB",
    networkType: "1",
    device: "PC",
    apiVersion: "5.23.0"
  }
}

function getCommonfromLoc(initParams) {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))
  return {
    ...initParams,
    yuuId: commonReqParams.yuuId,
    dmTenantId: commonReqParams.dmTenantId,
    vendorId: commonReqParams.venderId,
    storeId: commonReqParams.storeId,
    "dmall-locale": commonReqParams["superweb-locale"],
    lat: commonReqParams.deliveryLat,
    lng: commonReqParams.deliveryLng
  }
}

let baseUrl = domainAdaptationURL()
if (process.env.NODE_ENV === "production") {
  baseUrl = baseUrl + process.env.VUE_APP_PAY_API
} else {
  baseUrl = process.env.VUE_APP_PAY_API
}

export function queryMerchantInfo(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/queryMerchantInfo",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl
    }
  )
}

export function queryPromotion(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/queryPromotion",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl
    }
  )
}

export function cardList(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/cardList",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl,
      loading: true
    }
  )
}

export function bindCard(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/bindCard",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl
    }
  )
}

export function threeDs2AuthInit(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/threeDs2AuthInit",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl
    }
  )
}

export function threeDs2AuthPayer(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/threeDs2AuthPayer",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl
    }
  )
}

export function authorizePay(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/authorizePay",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl
    }
  )
}

export function unbindCard(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "dfpay/unbindCard",
      ...commonParams,
      ...params
    },
    {
      baseURL: baseUrl,
      loading: true
    }
  )
}

export function pay(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "cashier/pay",
      ...commonParams,
      params: JSON.stringify({
        payWay: 900,
        payChannelId: 800000,
        terminalType: 0,
        source: 1,
        type: 1,
        vendorId: commonParams.vendorId,
        stationNo: commonParams.storeId,
        ...params
      })
    },
    {
      baseURL: baseUrl,
      shouldErrorHandler: true
    }
  )
}

export function payList(params) {
  const commonParams = getCommonfromLoc(initParams)
  const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""

  return Post(
    "",
    {
      functionId: "cashier/payList",
      ...commonParams,
      params: JSON.stringify({
        orderType: 1,
        vendorId: commonParams.vendorId,
        stationNo: commonParams.storeId,
        userId: accountInfo ? accountInfo.custId : "",
        ...params
      })
    },
    {
      baseURL: baseUrl,
      shouldErrorHandler: true
    }
  )
}

export function queryTradeRecord(params) {
  const commonParams = getCommonfromLoc(initParams)
  return Post(
    "",
    {
      functionId: "trade/queryTradeRecord",
      ...commonParams,
      params: JSON.stringify({
        ...params
      })
    },
    {
      baseURL: baseUrl,
      shouldErrorHandler: true
    }
  )
}
